import { get, ref } from "firebase/database";
import { db } from "../lib/firebase";
import { collectAlertItemIds } from "./campaignAlerts";

import { LaunchError } from "./errors";
import { store } from "../app/store";

const EMPTY_ITEM_STATUSES = {
  ad: {},
  adGroup: {},
  assetsGroup: {},
};

const readStatusMap = async (basePath, ids) => {
  if (!basePath || ids.length === 0) {
    return {};
  }

  const entries = await Promise.all(
    ids.map(async (id) => {
      try {
        const snapshot = await get(ref(db, `${basePath}/${id}/status`));
        return [id, snapshot.exists() ? snapshot.val() : null];
      } catch (error) {
        store.dispatch(
          LaunchError(error, false, [], {
            functionName: "readStatusMap",
            capture: "exception",
          })
        );
        console.error("Error reading alert item status", {
          basePath,
          id,
          error,
        });
        return [id, null];
      }
    })
  );

  return Object.fromEntries(entries);
};

export const fetchAlertItemStatuses = async ({
  campaigns = {},
  paths = {},
}) => {
  const ids = collectAlertItemIds(campaigns);
  const hasIds =
    ids.adIDs.length > 0 ||
    ids.adGroupIDs.length > 0 ||
    ids.assetsGroupIDs.length > 0;

  if (!hasIds) {
    return EMPTY_ITEM_STATUSES;
  }

  const [ad, adGroup, assetsGroup] = await Promise.all([
    readStatusMap(paths.pathAds, ids.adIDs),
    readStatusMap(paths.pathAdSets, ids.adGroupIDs),
    readStatusMap(paths.pathAssetsGroups, ids.assetsGroupIDs),
  ]);

  return { ad, adGroup, assetsGroup };
};
